import styles from "./AlterarValorFornecedor.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Loading from "../../../../components/components-ui/Loading/Loading";
import Button from "../../../../components/components-ui/Button/Button";
import { Table } from "../../../../components/Table";
import { Grid, Col } from "../../../../components/Grid";
import api from "../../../../services/Api";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useContext, useEffect, useState } from "react";
import {
  customStyles,
  SelectSearch,
} from "../../../../components/components-ui/SelectSearch/SelectSearch";
import Select from "react-select";
import InputClear from "../../../../components/components-ui/InputClear/InputClear";
import { useOrdenacao } from "../../../../utils/useOrdenacao";
import CustomConfirmAlert from "../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";
import { toast } from "react-toastify";
import { AuthContext } from "../../../../Provider/AuthContext";
import { useVerificaPermissao } from "../../../../utils/verificaPermissao";

const formatterNumber = (number) => {
  const formatted = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(number);

  return formatted;
};

const API_VIEW_FORNECEDORES = "/gestao/alterarfornecedor/index";
const API_ALTERAR_VALORES = "/gestao/alterarvalores";

// Colunas da tabela
const columns = [
  {
    column: "Data Freg.",
    key: "DataFormatada",
  },
  {
    column: "Nº Coleta",
    key: "IDColeta",
  },
  {
    column: "Cod. Forn.",
    key: "CodForn",
  },
  {
    column: "Marca",
    key: "Marca",
  },
  {
    column: "Grupo",
    key: "IDGrupo",
  },
  {
    column: "Forma Pagto.",
    key: "TipoPagamento",
  },
  {
    column: "Valor Fornecedor",
    key: "ValorFornecedor",
  },
  {
    column: "Volume Óleo",
    key: "QuantidadeTotal",
  },
  {
    column: "Valor Total Pagto.",
    key: "ValorPagamento",
  },
];

export default function AlterarValorFornecedor() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [grupo, setGrupo] = useState([]);
  const [dadosTabela, setDadosTabela] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterTable, setFilterTable] = useState("");

  const { dados, ordenar, ordem, setDados } = useOrdenacao(
    dadosTabela,
    setDadosTabela
  );

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela de alterar valor fornecedor
    verificaPermissao(idTipoUsuario, 86);
  }, []);

  async function getGrupo() {
    await api
      .get(`/grupo/index`)
      .then((res) => setGrupo(res.data))
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    getGrupo();
  }, []);

  const alterarValores = async (values, setFieldValue) => {
    const data = {
      valorFornecedor: values?.valorFornecedor || null,
      idColeta: values?.numeroColeta || null,
      dataDe: values?.dataFreguesiaDe || null,
      dataAte: values?.dataFreguesiaAte || null,
      idLocal: values?.codigoLocal || null,
      nomeMarca: values?.nomeMarca || null,
      idGrupo: values?.grupo || null,
    };

    if (!data.valorFornecedor) {
      toast.warn("Informe o valor.");
      return;
    }

    if (Object.values(data).every((val) => val == null || val === "")) {
      toast.warn("Nenhum parâmetro informado.");
      return;
    }

    CustomConfirmAlert({
      subtitle: `Confirmar alteração do valor do(s) fornecedor(es) para R$ ${values?.valorFornecedor?.toFixed(
        2
      )}?`,
      labelBtnConfirmar: "Confirmar",
      onConfirm: async () => {
        const promise = api.post(API_ALTERAR_VALORES, data).then((response) => {
          const res = response.data;
          if (res.error !== 0) {
            throw new Error(res.msg || `Erro: ${res.error}`);
          }
          return response;
        });

        toast.promise(promise, {
          pending: "Alterando valores, aguarde...",
          success: {
            render({ data }) {
              return data.data.msg || `Valores alterados com sucesso`;
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao alterar valores";
            },
          },
        });

        try {
          const response = await promise;
          getFornecedores();
          setFieldValue("valorFornecedor", "");
        } catch (error) {
          console.error("Erro ao alterar valores: ", error);
        }
      },
    });
  };

  const getFornecedores = async () => {
    setShowLoading(true);
    await api
      .get(API_VIEW_FORNECEDORES + `?page=${currentPage}${filterTable}`)
      .then((res) => {
        setDadosTabela(res.data.data);
        setTotalPages(res.data.totalPages);
        setCurrentPage(res.data.currentPageNumber);
      })
      .catch((error) => console.log(error));
    setShowLoading(false);
  };

  useEffect(() => {
    // Impedir de executar ao abrir
    if (!filterTable) {
      return;
    }

    getFornecedores();
  }, [currentPage, filterTable]);

  async function filter(values) {
    let data = `${
      values?.dataFreguesiaDe
        ? `&data_freguesia_de=${values?.dataFreguesiaDe}`
        : ""
    }`;
    data =
      data +
      `${
        values?.dataFreguesiaAte
          ? `&data_freguesia_ate=${values?.dataFreguesiaAte}`
          : ""
      }`;
    data =
      data +
      `${values?.numeroColeta ? `&id_coleta=${values?.numeroColeta}` : ""}`;
    data =
      data + `${values?.codigoLocal ? `&id_local=${values?.codigoLocal}` : ""}`;
    data =
      data + `${values?.nomeMarca ? `&nome_marca=${values?.nomeMarca}` : ""}`;
    data = data + `${values?.grupo ? `&id_grupo=${values?.grupo}` : ""}`;

    if (!data) {
      toast.warn("Selecione alguma opção de filtro para buscar");
      return;
    }

    setCurrentPage(1);
    setFilterTable(data);
  }

  function resetFilters(resetForm, setFieldValue) {
    resetForm();
    setFilterTable("");
    setDadosTabela([]);
    setCurrentPage(1);
  }

  function previewPage() {
    if (currentPage === 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(currentPage - 1);
    }
  }
  function nextPage() {
    if (currentPage === totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(currentPage + 1);
    }
  }

  const ValidationSchema = Yup.object().shape({
    numeroColeta: Yup.string(),
    dataFreguesiaDe: Yup.date().max(
      new Date(),
      "Não é possível filtrar por uma data futura"
    ),
    dataFreguesiaAte: Yup.string(),
    codigoLocal: Yup.string(),
    nomeMarca: Yup.string(),
    // grupo: Yup.string(),
    valorFornecedor: Yup.number().min(0.1, "Insira uma quantidade válida"),
    // .required("Campo Obrigatório"),
  });

  return (
    <Container>
      <h3>Alteração de Valores</h3>
      <div className={styles.content}>
        <Formik
          initialValues={{
            numeroColeta: "",
            dataFreguesiaDe: "",
            dataFreguesiaAte: "",
            codigoLocal: "",
            nomeMarca: "",
            grupo: null,
            valorFornecedor: "",
          }}
          validationSchema={ValidationSchema}
          onSubmit={(values) => filter(values)}
        >
          {({ values, errors, touched, resetForm, setFieldValue }) => (
            <Form>
              <section className={styles.wrap}>
                <div className={styles.filter_header}>
                  <strong>Filtros</strong>
                  <div style={{ display: "flex", gap: 10 }}>
                    <Button title="Procurar" type="submit" />
                    <Button
                      type="button"
                      title="Limpar filtros"
                      color="tertiary"
                      onClick={() => resetFilters(resetForm, setFieldValue)}
                    />
                  </div>
                </div>
                <Grid>
                  <Col size={1}>
                    <label>Nº Coleta</label>
                    <Field type="text" name="numeroColeta">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() => setFieldValue("numeroColeta", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroColeta && touched.numeroColeta ? (
                      <span className={styles.alertError}>
                        {errors.numeroColeta}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Data Freg. De</label>
                    <Field type="date" name="dataFreguesiaDe" />
                    {errors.dataFreguesiaDe && touched.dataFreguesiaDe ? (
                      <span className={styles.alertError}>
                        {errors.dataFreguesiaDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Data Freg. Até</label>
                    <Field type="date" name="dataFreguesiaAte" />
                    {errors.dataFreguesiaAte && touched.dataFreguesiaAte ? (
                      <span className={styles.alertError}>
                        {errors.dataFreguesiaAte}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label>Cód Local</label>
                    <Field type="text" name="codigoLocal">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() => setFieldValue("codigoLocal", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.codigoLocal && touched.codigoLocal ? (
                      <span className={styles.alertError}>
                        {errors.codigoLocal}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Nome Marca</label>
                    <Field type="text" name="nomeMarca">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() => setFieldValue("nomeMarca", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.nomeMarca && touched.nomeMarca ? (
                      <span className={styles.alertError}>
                        {errors.nomeMarca}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={3}>
                    <label>Grupo</label>
                    <Field
                      name="grupo"
                      component={SelectSearch}
                      options={grupo.map((values) => ({
                        label: values?.descricao_grupo,
                        value: values?.id_grupo,
                      }))}
                    />
                    {errors.grupo && touched.grupo ? (
                      <span className={styles.alertError}>{errors.grupo}</span>
                    ) : null}
                  </Col>
                </Grid>
              </section>
              {dados.length ? (
                <div className={styles.container_table}>
                  <Table columns={columns} onSort={ordenar} ordem={ordem}>
                    {!showLoading
                      ? dados.map((values, index) => (
                          <tr key={index}>
                            <td>{values?.DataFormatada}</td>
                            <td>{values?.IDColeta}</td>
                            <td>{values?.CodForn}</td>
                            <td style={{ textAlign: "start" }}>
                              {values?.Marca}
                            </td>
                            <td style={{ textAlign: "start" }}>
                              {values?.Grupo}
                            </td>
                            <td style={{ textAlign: "start" }}>
                              {values?.TipoPagamento}
                            </td>
                            <td style={{ textAlign: "end" }}>
                              {values?.ValorFornecedor?.toFixed(2)}
                            </td>
                            <td style={{ textAlign: "end" }}>
                              {values?.QuantidadeTotal}
                            </td>
                            <td style={{ textAlign: "end" }}>
                              {values?.ValorPagamento?.toFixed(2)}
                            </td>
                          </tr>
                        ))
                      : null}
                  </Table>
                </div>
              ) : (
                <p style={{ textAlign: "center", marginBottom: "20px" }}>
                  {showLoading
                    ? ""
                    : !showLoading && filterTable
                    ? "Nenhuma opção encontrada"
                    : "Filtre para buscar"}
                </p>
              )}
              <div className={styles.loading}>
                <Loading display={showLoading ? "block" : "none"} />
              </div>

              <div className={styles.table_pagination}>
                {dados.length ? (
                  <div className={styles.table_pagination_buttons}>
                    <Button
                      disabled={currentPage === 1 ? true : false}
                      onClick={() => previewPage()}
                      type="button"
                    >
                      <i
                        style={{ marginRight: 5 }}
                        className="fas fa-chevron-left"
                      ></i>
                      Voltar
                    </Button>
                    <span>
                      {currentPage} De {totalPages}
                    </span>
                    <Button
                      disabled={
                        currentPage === totalPages || totalPages === 0
                          ? true
                          : false
                      }
                      type="button"
                      onClick={() => nextPage()}
                    >
                      Próxima
                      <i
                        style={{ marginLeft: 5 }}
                        className="fas fa-chevron-right"
                      ></i>
                    </Button>
                  </div>
                ) : null}
              </div>
              {dados.length ? (
                <Grid>
                  <Col size={2}>
                    <label>Novo Valor Fornecedor</label>
                    <Field type="number" name="valorFornecedor">
                      {({ field }) => (
                        <InputClear
                          type="number"
                          onClick={() => setFieldValue("valorFornecedor", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.valorFornecedor && touched.valorFornecedor ? (
                      <span className={styles.alertError}>
                        {errors.valorFornecedor}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <Button
                      className={styles.button}
                      type="button"
                      onClick={() => alterarValores(values, setFieldValue)}
                      disabled={!values.valorFornecedor}
                    >
                      Alterar Preço
                      <i
                        style={{ marginLeft: 5, color: "white" }}
                        className="fas fa-check"
                      ></i>
                    </Button>
                  </Col>
                </Grid>
              ) : null}
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}
